import { useCallback } from "react"
import { defaultSettings } from "../lib/defaultValues"
// import { Protocol } from "../lib/constants"
import { handleErrors } from "./handleErrors"
import { addInHistory, setInContextHelper } from "./helpers/setInContextHelper"
import { logger } from "../helpers/logger"

export const useReceiveMessages = ({
  setctx,
  roundUpdate,
  placeBetResponce,
  roundUserUpdate,
  cashoutResponce,
  handleNotification,
  handleErrorText,
  setErrorCode,
  updateSettings,
}: any) => {
  const receiveMessage = useCallback(
    (msg: any) => {
      if (msg === null) return logger.log("receiveMessage msg === null ", msg)
      else if (msg.code) {
        console.error("%cERROR", "color:aqua", msg)
        handleErrors(msg.code, handleErrorText, handleNotification)
        setErrorCode(msg.code)
      } else {
        // logger.log(msg, "msg in recieve msgs")
        switch (msg.service) {
          case "cashout":
            cashoutResponce(msg.data)
            break
          case "placebet":
            logger.log("placebet", msg)
            placeBetResponce(msg.data)
            setInContextHelper(msg, setctx)
            const code = msg.data.error.code
            code !== 0 &&
              code !== 112 &&
              handleErrors(code, handleErrorText, handleNotification)
            break
          case "roundupdate":
            roundUpdate(msg.data)
            break
          case "userupdate":
            logger.log("userupdate", msg)
            roundUserUpdate(msg.data)
            break
          case "history":
            return addInHistory(msg.data, setctx)
          case "settings":
            logger.log(msg.data, "settings")
            const checksettings =
              Object.keys(msg.data).length === 0 ? defaultSettings : msg.data
            updateSettings(checksettings)
            break
          case "auth":
          case "config":
          case "bet":
          case "train":
          case "ping":
            logger.log("", msg)
            setInContextHelper(msg, setctx)
            break
          case "jackpot":
            break
          case "disconnect":
            logger.log("%cDISCONNECT", "color:aqua", msg)
            handleErrors("", handleErrorText, handleNotification)
            break
          default:
            console.error(
              "receiveMessage switch default case",
              msg // ErrorTypes[msgObject.errorCode],
            )
            break
        }
      }
    },
    [
      setctx,
      setErrorCode,
      handleNotification,
      handleErrorText,
      roundUpdate,
      placeBetResponce,
      roundUserUpdate,
      cashoutResponce,
      updateSettings,
    ]
  )

  return receiveMessage
}
